import http from "./http";

/**
 * Service for the /impuestos API (Trello #306 — PR5).
 * Covers the tax catalog (impuestos + alícuotas ABM), bulk assignment
 * by scope (preview/aplicar) and the single-product assignment endpoint.
 *
 * All calls go through the central `http` instance — never raw axios.
 */

const BASE = "impuestos";

// ─── Catálogo de impuestos ────────────────────────────────────────────────

const getCatalogo = () => http.get(BASE);

const crearImpuesto = (data) => http.post(BASE, data);

const actualizarImpuesto = (idImpuesto, data) =>
  http.put(`${BASE}/${idImpuesto}`, data);

const eliminarImpuesto = (idImpuesto) => http.delete(`${BASE}/${idImpuesto}`);

// ─── Alícuotas ─────────────────────────────────────────────────────────────

const crearAlicuota = (idImpuesto, data) =>
  http.post(`${BASE}/${idImpuesto}/alicuotas`, data);

const actualizarAlicuota = (idImpuesto, idAlicuota, data) =>
  http.put(`${BASE}/${idImpuesto}/alicuotas/${idAlicuota}`, data);

const eliminarAlicuota = (idImpuesto, idAlicuota) =>
  http.delete(`${BASE}/${idImpuesto}/alicuotas/${idAlicuota}`);

// ─── Asignación masiva por alcance ─────────────────────────────────────────

const getAsignaciones = () => http.get(`${BASE}/asignaciones`);

// Nunca escribe — vista previa obligatoria antes de aplicar (spec/design PR5).
const previewAsignacion = (payload) =>
  http.post(`${BASE}/asignaciones/preview`, payload);

const aplicarAsignacion = (payload) =>
  http.post(`${BASE}/asignaciones/aplicar`, payload);

// ─── Asignación puntual a un producto (siempre origen='manual' en backend) ─

const asignarImpuestoProducto = (productId, payload) =>
  http.put(`productos/${productId}/impuestos`, payload);

// ─── Catálogos auxiliares para el diálogo de asignación masiva (PR6) ───────
// Ambos endpoints devuelven un array JSON directo (sin envelope) — ver
// GET /productos/categorias y /productos/marcas (contrato verificado contra
// el backend PR6, marcas_controller.js / categoria.service.js).

const getCategorias = () => http.get("productos/categorias");

const getMarcas = () => http.get("productos/marcas");

export default {
  getCatalogo,
  crearImpuesto,
  actualizarImpuesto,
  eliminarImpuesto,
  crearAlicuota,
  actualizarAlicuota,
  eliminarAlicuota,
  getAsignaciones,
  previewAsignacion,
  aplicarAsignacion,
  asignarImpuestoProducto,
  getCategorias,
  getMarcas,
};
